interface StatisticTabProps {
  children: JSX.Element[];
}

function StatisticTab( { children  }: StatisticTabProps ) {
  return (
    <div className="bg-white rounded-xl shadow-md border flex flex-center flex-col overflow-hidden h-[32rem]">
      { children }
    </div>
  );
}

export default StatisticTab;
